import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  const classes = inputs.filter((input) => !!input);
  return twMerge(clsx(classes));
}

export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export const toSentenceCase = (text: string) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const kebabCase = (s: string) =>
  s
    .trim()
    .replace(/[\s_]+/g, "-")
    .toLowerCase();
